import dynamic from 'next/dynamic';

const LL = dynamic(()=> import("@/hoc/LazyLoader"),
  { loading: () => <p className="loading-box"></p>, ssr: true }
);

const InfoGraphics = dynamic(() => import("../../../../components/home/InfoGraphics"),
  { loading: () => <p className="loading-box"></p>, ssr: true }
);

const GenericSlider = dynamic(() => import("./GenericSlider"),
  { loading: () => <p className="loading-box"></p>, ssr: true }
);

const PromotionBanner = dynamic(() => import("./PromotionBanner"),
  { loading: () => <p className="loading-box"></p>, ssr: true }
);

const TopGrid = dynamic(() => import("./TopGrid"),
  { loading: () => <p className="loading-box"></p>, ssr: true }
);

const HeroProduct = dynamic(() => import("./HeroProduct"),
  { loading: () => <p className="loading-box"></p>, ssr: true }
);

const EWLayout = props => {
  const { TopGridProps, CompleteMobileProtectionProps, ProtectionPlansStartingAtPriceProps, HeroProductProps, PromotionBannerOneProps } = props;
  return (
    <>
      <TopGrid {...TopGridProps} bgColor="white_bg" />
      <InfoGraphics title="Why Choose Us" variant='secondary' bgColor="gray_bg" />
      <LL><PromotionBanner {...PromotionBannerOneProps} bgColor="white_bg"  banner="one" /></LL>
      <hr className="bottom_border" />
      {/* <LL><GenericSlider {...CompleteMobileProtectionProps} bgColor="white_bg" number="One"/></LL> */} {/* Temorarily commenting complete mobile protection protection section */}
      <LL><GenericSlider {...ProtectionPlansStartingAtPriceProps} bgColor="light_bg" number="Two"/></LL>
      {/* <LL><HeroProduct {...HeroProductProps} bgColor="light_bg" /></LL> */}
      <hr className="bottom_border" />
    </>
  )
}

export default EWLayout